module.exports = {"misc":{"exampleQuery":"('artificial intelligence' OR 'machine learning') AND ('natural language processing' OR NLP) AND NOT 'neuro-linguistic programming'","primarySyntaxMethod":"Ovid/PubMed","secondarySyntaxMethod":"Other","orLowerCase":"or","ai":{"title":"2Dsearch AI"}},"buttons":{"confirm":"Confirm","cancel":"Cancel","close":"Close"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-uk/misc.json
// module id = Vlg7
// module chunks = 1